export default {
    analysisTools: 'Otras herramientas',
    collapse: 'Colapsar',
    expand: 'Expandir',
    display: 'Display',
    customAnalysis: 'Análisis personalizado',
    automaticInsights: 'Insights automáticos',
    insightsAndAlerts: 'Insights y alertas',
    dashboards: 'Dashboards',
    settings: 'Configuración',
}
